module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/FiberglassCalculator-e7cb6040882fc5c461500195135c58e3.png";